import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import copy from 'copy-to-clipboard';
import PropTypes from 'prop-types';
import React from 'react';

const CopyableContent = ({ contentToCopy, message }) => {
  const theme = useTheme();
  const [isCopied, setIsCopied] = React.useState(false);

  const handleCopy = () => {
    copy(contentToCopy);
    setIsCopied(true);
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      onClick={handleCopy}
      sx={{
        backgroundColor: 'rgba(187, 222, 251, 0.18)',
        p: 2,
        borderRadius: 1,
        border: `1px solid ${theme.palette.primary.light}`,
        cursor: 'pointer'
      }}
    >
      <Stack spacing={1}>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.grey[600]
          }}
        >
          {message}
        </Typography>
        <Typography
          variant="body1"
          sx={{ letterSpacing: 1.5, color: theme.palette.grey[700] }}
        >
          {String(contentToCopy)}
        </Typography>
      </Stack>
      <Stack>
        <Tooltip title={!isCopied ? 'Copiar' : 'Copiado'}>
          <IconButton onClick={handleCopy} size="large">
            {isCopied ? (
              <CheckCircleIcon
                fontSize="large"
                sx={{ color: theme.palette.success.main }}
              />
            ) : (
              <ContentCopyIcon fontSize="large" />
            )}
          </IconButton>
        </Tooltip>
      </Stack>
    </Stack>
  );
};

CopyableContent.propTypes = {
  contentToCopy: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};

export default CopyableContent;
